// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart {
    background-color: #ffffff;
    border-radius: 4px;
    margin: 0.5rem;
}

.empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
}

.cart-footer {
    padding: 1rem;
}

.image-container {
    max-height: 10rem;
    max-width: 8rem;
}

.checkout-btn {
    text-transform: none;
    font-weight: 700;
    font-size: 1.1rem;
}

.empty-cart-icon {
    width: 3rem !important;
    height: 3rem !important;
    color: #aaa;
}

.cart-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/Cart.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".cart {\n    background-color: #ffffff;\n    border-radius: 4px;\n    margin: 0.5rem;\n}\n\n.empty {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 60vh;\n}\n\n.cart-footer {\n    padding: 1rem;\n}\n\n.image-container {\n    max-height: 10rem;\n    max-width: 8rem;\n}\n\n.checkout-btn {\n    text-transform: none;\n    font-weight: 700;\n    font-size: 1.1rem;\n}\n\n.empty-cart-icon {\n    width: 3rem !important;\n    height: 3rem !important;\n    color: #aaa;\n}\n\n.cart-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
